class TG_ProductQuickviewDrawerVariant {
    constructor(container) {
  
      this.element = container;
      this.delegateElement = new themegoal.libs.Delegate(this.element);
      this.options = JSON.parse(this.element.getAttribute('data-section-settings'));
  
      this.productVariants = new themegoal.components_business.product_variants.ProductVariants(this.element, this.options);

      this.mediaIdIndexs = null;
      if(this.element.querySelector('[data-product-media-id-index-json]')){
        let productMediaJsonData = JSON.parse(this.element.querySelector('[data-product-media-id-index-json]').innerHTML);
        this.mediaIdIndexs = productMediaJsonData['media_id_index'];
      }
    
      let productSlideshowElement = this.element.querySelector('.ProductGallery__Carousel');
      let productSlideshowNavElement = this.element.querySelector('.ProductGallery__Thumbs');
  
      if (productSlideshowElement) {
        this.productSlideshow = new themegoal.components.Carousel(productSlideshowElement);
      }
  
      if (productSlideshowNavElement) {
        new themegoal.components.Carousel(productSlideshowNavElement);
      }
  
      this._bindEventsListeners();
    }
  
    _bindEventsListeners() {
      this.delegateElement.on('variant:changed', this._updateSlideshowImage.bind(this));
    }

    _updateSlideshowImage(event) {
      var _this = this;
      var variant = event.detail.variant,
          previousVariant = event.detail.previousVariant;
  
      if (!variant || !variant['featured_media'] || previousVariant && previousVariant['featured_media'] && previousVariant['featured_media']['id'] === variant['featured_media']['id']) {
          return;
      }
  
      let variantFeaturedMediaId = variant['featured_media']['id'];

      if (this.options['galleryDesign'] == 'carousel' && this.productSlideshow) {
        if(this.options["enableMediaGrouping"]&&previousVariant.options[0]!=variant.options[0]){
          this.mediaIdIndexs = null;
          if(this.element.querySelector('[data-product-media-id-index-json]')){
            let productMediaJsonData = JSON.parse(this.element.querySelector('[data-product-media-id-index-json]').innerHTML);
            this.mediaIdIndexs = productMediaJsonData['media_id_index'];
          }
          this.productSlideshowNavElement = this.element.querySelector('.ProductGallery__Thumbs');
          this.productSlideshowElement = this.element.querySelector('.ProductGallery__Carousel');
          
          if (this.productSlideshowNavElement) {
            this.productSlideshowNav = new themegoal.components.Carousel(this.productSlideshowNavElement);
          }

          if (this.productSlideshowElement) {
            this.productSlideshow = new themegoal.components.Carousel(this.productSlideshowElement);
          }
        }
        
        if (this.mediaIdIndexs && this.mediaIdIndexs.hasOwnProperty("id_" + variantFeaturedMediaId)){
          this.productSlideshow.selectCell(this.mediaIdIndexs["id_" + variantFeaturedMediaId]);
        }

        let carouselEle = _this.productSlideshow.carouselInstance.el.querySelectorAll(".Carousel__Item");
          carouselEle.forEach(function (ele) {
            ele.classList.remove("Carousel__Item--currentItem");
          });

        setTimeout(function () {
          let carouselEle = _this.productSlideshow.carouselInstance.el.querySelectorAll(".Carousel__Item");
          carouselEle.forEach(function (ele) {
            if(ele.classList.contains("Carousel__Item--active") && !ele.classList.contains("Carousel__Item--currentItem"))
            ele.classList.add("Carousel__Item--currentItem"); 
          });
        }, 800);
      } 
    
    }
  
  }
if (!customElements.get('section-quick-view-drawer')) {
  class TG_SectionQuickViewDrawer extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.element = this;
      this.delegateElement = new themegoal.libs.Delegate(this.element);
      this.documentDelegate = new themegoal.libs.Delegate(document.documentElement);
  
      this._bindEventsListeners();
    }

    disconnectedCallback(){
      if(this.delegateElement)this.delegateElement.destroy();
      if(this.documentDelegate)this.documentDelegate.destroy();
    }
  
    _bindEventsListeners() {
   
  
    }
      
  }
        
  customElements.define('section-quick-view-drawer', TG_SectionQuickViewDrawer);
}

if (!customElements.get('quick-view-drawer-button')) {
  class TG_QuickViewDrawerButton extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.delegateElement = new themegoal.libs.Delegate(this);
      this.delegateElement.on('click', '[data-action="quick-view"]', this._openQuickViewDrawer.bind(this));
    }

    disconnectedCallback(){
      if(this.delegateElement)this.delegateElement.destroy();
    }

   _openQuickViewDrawer(event,target) {

      event.preventDefault();

      let _this = this;
  
      let productURL = target.getAttribute('data-product-handle');

      if(productURL){
        document.dispatchEvent(new CustomEvent('theme:loading:start'));

        target.classList.add("Loading");
  
        fetch(window.routes.rootUrlWithoutSlash+'/products/'+productURL+'?section_id=quick-view-drawer', {
          credentials: 'same-origin',
          method: 'GET'
        }).then(function (response) {
          response.text().then(function (content) {
            document.dispatchEvent(new CustomEvent('theme:loading:end'));

            target.classList.remove("Loading");
            var tempElement = document.createElement('div');
            tempElement.innerHTML = content;

            let ele = document.getElementById('QuickViewDrawer');
            
            console.log("tempElement ", tempElement );

            ele.querySelector("[data-quick-view-drawer-content]").innerHTML = tempElement.querySelector("#shopify-section-quick-view-drawer").querySelector("[data-quick-view-drawer-content]").innerHTML;

            
            document.querySelector("body").style.removeProperty('overflow');
            
            _this.quiviewDrawer = new themegoal.components.Drawer(ele);
            window.quiviewDrawer =  _this.quiviewDrawer;
             ele.addEventListener('shown.tg.Drawer', event => {
               new TG_ProductQuickviewDrawerVariant(ele.querySelector("[data-quick-view-drawer-content]"));
             })
        
            _this.quiviewDrawer.show();
              
          });
        });
      
      }
    }

  _debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }
  }
  
  customElements.define('quick-view-drawer-button', TG_QuickViewDrawerButton);
}